module.exports = __webpack_public_path__ + "media/images/brands/marque-majirel@2x-9a6d9fbc1f6e567548bfb03dda151331.jpg";